import React from 'react'
import { StAllProductsWrapper } from 'src/utils/styles'
import Seo from 'src/components/seo'
import { graphql } from 'gatsby'
import { useFilter } from 'src/hooks/useFilter'
import { ProductGridWrapper } from 'src/components/ProductGridWrapper'
import { useNavigation } from 'src/hooks/useNavigation'
import { useTranslation } from 'react-i18next'

const IndexPage = data => {
  const { allShopifyProduct } = data.data

  const {
    styleFilter,
    colorFilter,
    sizeFilter,
    collectionFilter,
    promotionsFilter,
    sorting,
    SortDropdown,
    ColorFilterList,
    ColorFilterListMobile,
    SizeFilterList,
    SizeFilterListMobile,
    StyleFilterList,
    CollectionFilterList,
    PromotionsFilterList,
    selectedFilterCount,
    allFilterValues,
    removeFilterValue,
    clearAllFilters,
  } = useFilter(allShopifyProduct.edges)

  const { SidebarNavigation } = useNavigation(
    false,
    StyleFilterList,
    CollectionFilterList,
    SizeFilterList,
    ColorFilterList,
    PromotionsFilterList,
    selectedFilterCount
  )
  const { t } = useTranslation('misc')
  const productCount = allShopifyProduct.totalCount

  return (
    <>
      <StAllProductsWrapper>
        <Seo
          title="All Products"
          keywords={[`lobster`, `lemonade`, `products`, `fashion`, `headwear`]}
        />
        {SidebarNavigation}
        <ProductGridWrapper
          selectedFilterCount={selectedFilterCount}
          allFilterValues={allFilterValues}
          removeFilterValue={removeFilterValue}
          clearAllFilters={clearAllFilters}
          headline={t('products.allProducts')}
          totalCount={productCount}
          styleFilter={styleFilter}
          collectionFilter={collectionFilter}
          promotionsFilter={promotionsFilter}
          sizeFilter={sizeFilter}
          colorFilter={colorFilter}
          sortDropdown={SortDropdown}
          sorting={sorting}
          colorFilterList={ColorFilterList}
          colorFilterListMobile={ColorFilterListMobile}
          sizeFilterList={SizeFilterList}
          sizeFilterListMobile={SizeFilterListMobile}
          styleFilterList={StyleFilterList}
          collectionFilterList={CollectionFilterList}
          promotionsFilterList={PromotionsFilterList}
          products={allShopifyProduct.edges}
        />
      </StAllProductsWrapper>
    </>
  )
}

export default IndexPage

export const query = graphql`
  query ($language: String!) {
    allShopifyProduct(
      filter: {
        id: {
          nin: [
            "7d894029-725f-50ea-9499-b68d86b4d647"
            "0d8bd49c-de01-59a4-9a94-7a9e96213bef"
            "d891e135-7e11-5f78-88c6-784a45419674"
            "1c77517e-187f-5794-b059-57b03147f286"
            "4ca5889f-ff3c-5647-8f98-45e336a7c258"
            "3a926ed2-9f3a-5130-9d40-e3aa872997b9"
            "101057a4-510e-50e2-82d6-c877d0cbf3f9"
            "bdc2dc09-6618-563a-9a21-e34c49fd479e"
            "c537205e-2e19-5aff-a820-bd856cba9918"
            "7aca87a0-4dea-5c84-9c27-7cec6611e211"
            "87eb9ae2-89fe-5049-bd22-364d6e130e60"
            "b60d0f08-0d2b-54d0-83e5-98e125d68452"
            "dae472f4-c45a-5515-b9d5-d525499f1426"
          ]
        }
        metafields: { elemMatch: { key: { ne: "excludeItem" } } }
      }
      sort: { createdAt: DESC }
    ) {
      totalCount
      edges {
        node {
          ...ShopifyProductFragment
        }
      }
    }
    locales: allLocale(
      filter: {
        ns: { in: ["misc", "footer", "lineItem", "shoppingCart", "productFilters", "cookies"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
